import React from 'react';
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import * as LucideIcons from 'lucide-react';

const ComplaintMethodCard = ({ method, onEdit, onDelete }) => {
    // Dynamically get the icon component from Lucide
    const IconComponent = LucideIcons[method.icon_name] || LucideIcons.HelpCircle;

    return (
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden hover:shadow-md transition-all group">
            <div className={`h-2 bg-primary-500`}></div>

            <div className="p-5">
                <div className="flex items-start justify-between mb-4">
                    <div className={`p-3 rounded-xl bg-primary-100 text-primary-600 shadow-sm`}>
                        <IconComponent className="h-6 w-6" />
                    </div>
                    <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button
                            onClick={() => onEdit(method)}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-primary-600 transition-colors"
                            title="Edit"
                        >
                            <PencilIcon className="h-5 w-5" />
                        </button>
                        <button
                            onClick={() => onDelete(method.id)}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-red-600 transition-colors"
                            title="Delete"
                        >
                            <TrashIcon className="h-5 w-5" />
                        </button>
                    </div>
                </div>

                <div className="space-y-2">
                    <div className="flex items-center justify-between">
                        <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ${method.is_active ? 'bg-green-50 text-green-600' : 'bg-slate-100 text-slate-500'}`}>
                            {method.is_active ? 'Active' : 'Inactive'}
                        </span>
                        <span className="text-[10px] font-bold text-slate-400">ORDER #{method.display_order}</span>
                    </div>
                    <h3 className="text-slate-800 font-bold">{method.title}</h3>
                    <p className="text-slate-500 text-sm line-clamp-2">
                        {method.description}
                    </p>
                    {method.type === 'link' && (
                        <div className="text-[10px] text-primary-600 font-mono overflow-hidden text-ellipsis whitespace-nowrap bg-primary-50 px-2 py-1 rounded">
                            {method.href}
                        </div>
                    )}
                    {method.type === 'popup' && (
                        <div className="text-[10px] text-amber-600 font-bold uppercase tracking-widest bg-amber-50 px-2 py-1 rounded">
                            Opens Popup Form
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ComplaintMethodCard;
